/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-audio-dialog.vue?vue&type=template&id=3e03dc6b&"
import script from "./add-audio-dialog.vue?vue&type=script&lang=js&"
export * from "./add-audio-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports